var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"guide"},[_vm._v("答え合わせ：正解を確認してマルバツをつけよう")])}
var staticRenderFns = []

export { render, staticRenderFns }